import { Box, Typography, useTheme } from '@mui/joy';
import { Divider } from '.';
import { useData } from '../../providers/DataProvider';
import { useYear } from '../../providers/YearProvider';

type ElectionCycleProps = {
	category: 'pre-filing' | 'primary' | 'general';
};

type CycleProps = {
	title: string;
	active: boolean;
	order: 'left' | 'middle' | 'right';
};

const Cycle = ({ title, active, order }: CycleProps) => {
	const theme = useTheme();
	const getColor = (active: boolean) =>
		active
			? theme.palette.chartElementsBackground.baseLine
			: theme.palette.chartElementsBackground.annotations;

	const getRadius = (order: CycleProps['order']) => {
		if (order === 'left') {
			return '8px 0 0 8px';
		}
		if (order === 'right') {
			return '0 8px 8px 0';
		}
		return '0 0 0 0';
	};

	const getOpacity = (active: boolean) => (active ? 1 : 0.19);
	return (
		<Box
			sx={{
				color: getColor(active),
				width: '100%',
				opacity: getOpacity(active)
			}}
		>
			{title}
			<Box
				sx={{
					height: 12,
					backgroundColor: getColor(active),
					width: '100%',
					borderRadius: getRadius(order)
				}}
			/>
		</Box>
	);
};

export const ElectionCycle = () => {
	const { electionCycle } = useData();
	const { year } = useYear();
	const getActive = (category2Check: ElectionCycleProps['category']) => {
		if (category2Check === electionCycle) {
			return true;
		}
		return false;
	};
	return (
		<>
			<Divider sx={{ my: '1rem' }} />
			<Box
				sx={{
					width: { xs: '100%', sm: 512 }
				}}
			>
				<Typography level='body1' sx={{ mb: '1rem' }}>
					Where are we in the {year} election cycle?
				</Typography>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						fontFamily: 'Source Sans Pro, sans-serif',
						fontSize: '1rem',
						gap: '2.25px'
					}}
				>
					<Cycle
						title='Pre-Filing'
						active={getActive('pre-filing')}
						order='left'
					/>
					<Cycle title='Primary' active={getActive('primary')} order='middle' />
					<Cycle title='General' active={getActive('general')} order='right' />
				</Box>
			</Box>
		</>
	);
};
